import {
  ensureLeadingSlash as ensureLeadingSlashUtil,
  joinPath,
  normalizePath as normalizePathUtil
} from '@paction-2.0/util';

export const ensureLeadingSlash = (value: string) =>
  ensureLeadingSlashUtil(value);

export const cleanPath = (value: string) => normalizePathUtil(value);

export const joinUrlSegments = (
  ...segments: Array<string | number | undefined | null>
) => {
  const encoded = segments
    .filter(
      (segment) => segment !== undefined && segment !== null && segment !== ''
    )
    .map((segment) => encodeURIComponent(String(segment)));

  if (encoded.length === 0) {
    return '/';
  }

  return joinPath(...encoded);
};
